import { useState, useEffect } from "react";
import { _get_minimum_orders } from "../common/axios_services";

const useMinimumOrder = (businessType) => {
  const [minimumOrder, setMinimumOrder] = useState(2500);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMinimumOrder = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await _get_minimum_orders();
      const data = response.data?.data;
      if (data && businessType) {
        if (businessType === "restaurant") {
          setMinimumOrder(data.restaurant || 2500);
        } else if (businessType === "raw_food") {
          setMinimumOrder(data.rawFoods || 5000);
        } else {
          setMinimumOrder(data.stores || 5000);
        }
      }
    } catch (err) {
      setError(err.message || "Failed to fetch minimum order");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMinimumOrder();
  }, []);

  return { minimumOrder, loading, error, refetch: fetchMinimumOrder };
};

export default useMinimumOrder;
